const faqs = [
  {
    q: '桔子视频是什么？和普通视频网站有什么不同？',
    a: '桔子视频是一个视频内容聚合导航平台，整合了红桃视频、樱桃视频、茄子视频、糖心视频等多个热门视频站点的内容。不同于单一视频网站，桔子视频让用户在一个页面就能浏览多个平台的最新影视资源，省去反复切换的麻烦。',
  },
  {
    q: '桔子视频是否需要注册或付费？',
    a: '桔子视频作为内容导航平台，完全免费使用，无需注册账号，无需付费。打开网站即可浏览各大平台的热门内容索引，找到感兴趣的视频后跳转至对应平台观看。',
  },
  {
    q: '为什么有些内容加载比较慢？',
    a: '桔子视频采用智能CDN加速和多线路自动切换技术，正常情况下播放流畅不缓冲。如遇网络波动，可尝试刷新页面或切换网络环境。我们持续优化播放体验，确保最佳观看效果。',
  },
  {
    q: '桔子视频更新频率是怎样的？',
    a: '我们坚持每日同步更新，各大平台的电视剧、短剧、综艺、电影等最新内容都会第一时间在桔子视频上展示。用户每天访问都能看到新鲜热乎的内容推荐，不会错过任何热门好片。',
  },
  {
    q: '如何在手机上使用桔子视频？',
    a: '桔子视频全面适配手机、平板、电脑等设备，无需下载安装任何APP。直接用手机浏览器访问即可获得良好的浏览体验，界面自适应屏幕大小，操作流畅便捷。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto">
            关于桔子视频，你想了解的一切
          </p>
        </div>

        <div className="max-w-[800px] mx-auto space-y-3">
          {faqs.map((item, i) => (
            <details
              key={i}
              className="group rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden"
            >
              <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
                <h3 className="text-sm md:text-base font-bold text-foreground-900 pr-4">
                  {item.q}
                </h3>
                <div className="w-6 h-6 rounded-full bg-background-200 flex items-center justify-center flex-shrink-0 group-open:rotate-45 transition-transform duration-300">
                  <i className="ri-add-line text-foreground-600 text-sm"></i>
                </div>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-sm text-foreground-700 leading-relaxed">{item.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}